import React, { useContext } from "react";
import { Field, Form } from "react-final-form";
import { Button, FormText } from "reactstrap";
import { TextInput } from "../../../../components/inputs/final_form/TextInput";
import { LoadingButton } from "../../../../components/LoadingButton";
import { api, redirectTo } from "../../../../util/api";
import { required } from "../../../../util/validators";
import { WizardContext } from "../../WizardContext";
import { MissingInfoCategoriesPicker } from "../../../../missing_info_categories/MissingInfoCategoriesPicker";

export const SalesforceContactScreen = () => {
  const {
    recordMiSalesforceContactUrl,
    dispatch,
    setLoading,
    setError,
    caseId,
    miCategories,
    initialMICategories,
    missingFields,
    noMissingInfoUrl,
  } = useContext(WizardContext);

  const onSubmit = async ({ missingInfoCategoryIds, salesforceMessage }) => {
    setLoading(true);
    setError(null);

    try {
      const { data } = await api.post(recordMiSalesforceContactUrl, {
        missing_info_category_ids: missingInfoCategoryIds,
        salesforce_message: salesforceMessage,
      });

      const url = data?.meta?.redirect_url;

      redirectTo(url, "Case has been put into Missing Information and sent to the lab. Please proceed with your next case.", "success");
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleResolveMissingInfo = () => dispatch({ type: "setAnswer", key: "anyRemainingMissingInfo", value: true, doTransition: true });

  const handleNoMissingInfo = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await api.post(noMissingInfoUrl);

      const url = response?.data?.meta?.redirect_url;

      redirectTo(url, "Missing Info Workflow canceled for Case.", "success");
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Form onSubmit={onSubmit}>
        {({ handleSubmit, submitting, form, submitSucceeded, values }) => {
          const messageLength = form.getState().values?.salesforceMessage?.length || 0;
          return (
            <>
              <div>
                <MissingInfoCategoriesPicker
                  caseId={caseId}
                  missingInfoCategories={initialMICategories}
                  initialCategories={miCategories}
                  saveUrl={""}
                  missingFields={missingFields}
                  form={form}
                  submitting={submitting}
                  submitSucceeded={submitSucceeded}
                />
              </div>

              <div className="mb-3">
                <Field
                  component={TextInput}
                  type="textarea"
                  label="Message"
                  required
                  validate={required}
                  name="salesforceMessage"
                  maxLength={255}
                >
                  <FormText>Please provide a description of what is missing to the lab. {messageLength}/255 characters.</FormText>
                </Field>
              </div>

              <div className="d-flex flex-row align-items-center">
                <LoadingButton loading={submitting} onClick={handleSubmit} className="me-2">
                  Send Missing Information to Lab
                </LoadingButton>

                <Button color="link" onClick={handleResolveMissingInfo}>
                  Resolve MI Now
                </Button>

                <Button color="link" onClick={handleNoMissingInfo}>
                  No Missing Information
                </Button>
              </div>
            </>
          );
        }}
      </Form>
    </>
  );
};
